// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new_chip-module__chip--3KyW1{background:#c42e54;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;color:#fff;font-size:10px;padding:4px 5px;line-height:1}\n", ""]);
// Exports
exports.locals = {
	"chip": "new_chip-module__chip--3KyW1"
};
module.exports = exports;
